import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import MarkAsCompleteModal from './MarkAsCompleteModal'
import LegendInfo from './LegendInfo'
import ClubService from 'src/service/ClubService'
import LegendInfoIndoor from './LegendInfoIndoor'
import TeamCommonScorecard from './TeamCommonScorecard'
import TeamIndoorScorecard from './TeamIndoorScorecard'

const ScoreCard = () => {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [defaultInning, setDefaultInning] = useState(1)
  const [scorecardDetails, setScorecardDetails] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [loader, setLoader] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [statusValue, setStatusValue] = useState()
  const param = useParams()
  const [gameDetails, setGameDetails] = useState({})
  const [scorecardColoumns, setScorecardColoumns] = useState([])
  const [commonScorecardLoading, setCommonScorecardLoading] = useState(false)
  const fetchData = async (defaultInning = 1) => {
    setScorecardDetails([])
    try {
      setCommonScorecardLoading(true)
      const scorecardResponse = await ScorecardService.scorecardDetail(
        param.fixtureId,
        defaultInning,
        param.teamId,
      )
      if (scorecardResponse.status === 200) {
        setScorecardDetails(scorecardResponse.data)
        if (scorecardResponse.player_list.length < 5) {
          ToastComponent(
            'Please add a minimum of 5 players to the squad list of this fixture!',
            'error',
          )
          navigate(`/manage-scores/team-players/${param.fixtureId}/${param.teamId}`)
          return // Exit early if player list is insufficient
        }
        setCommonScorecardLoading(false)

        setPlayerList(scorecardResponse.player_list)
        if (scorecardResponse.fixtureDetails?.potm) {
          const potmFromApi = scorecardResponse.fixtureDetails?.potm || []
          setSelectedValue(potmFromApi)
        }
        setFixtureDetails(scorecardResponse.fixtureDetails)
        setScorecardColoumns(scorecardResponse.scorecardColoumns)
        setStatusValue(scorecardResponse.fixtureDetails.status)
      }

      const clubResponse = await ClubService.getClubDetails()
      if (clubResponse.status === 200) {
        if (clubResponse?.game_details?.game_type == 1) {
          navigate(`/scorecard/${param.fixtureId}/${param.teamId}`)
        }
        setLoader(false)
        setIsLoading(false)
        setGameDetails(clubResponse.game_details)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error here, e.g., show an error toast
    }
  }

  useEffect(() => {
    fetchData()
    // Cleanup (if necessary)
    return () => {
      // Cleanup code here (if any)
    }
  }, [])
  const formik = useFormik({
    initialValues: {
      data: scorecardDetails,
      scorcard_link_name: fixtureDetails?.scorcard_link_name,
      scorcard_link_url: fixtureDetails?.scorcard_link_url,
      fall_of_wickets: fixtureDetails?.fall_of_wickets,
      match_report: fixtureDetails?.match_report,
      potm_match_status: fixtureDetails?.potm_match_status,
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      data.fixtureId = param.fixtureId
      data.potm = selectedValue
      data.status = statusValue
      data.inning = defaultInning
      setLoader(true)
      if (gameDetails?.game_type === 3) {
        ScorecardService.saveIndoorScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      } else {
        ScorecardService.saveScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      }
    },
  })
  const [selectedValue, setSelectedValue] = useState([])
  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : [])
  }
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      formikRef.current.handleSubmit()
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/scorecard/${param.fixtureId}`)
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }

  const formikRef = React.useRef()
  useEffect(() => {
    formikRef.current = formik
  }, [formik])

  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    fetchData(e.target.value)
  }

  const [isMobile, setIsMobile] = useState(false)
  // Function to update the isMobile state based on the screen width
  const updateScreenSize = () => {
    setIsMobile(window.innerWidth <= 768) // Adjust the breakpoint as needed
  }
  // Use useEffect to update the screen size state on component mount and window resize
  useEffect(() => {
    updateScreenSize() // Initial check
    window.addEventListener('resize', updateScreenSize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateScreenSize)
    }
  }, [])
  function formatFantasyPoints(fantasyPoints) {
    // Check if there are decimal digits
    if (fantasyPoints % 1 !== 0) {
      return fantasyPoints.toFixed(2).replace(/0+$/, '') // Remove trailing zeros
    } else {
      return fantasyPoints.toString() // Convert to a string without decimal places
    }
  }
  const [infoPageModal, setInfoPageModal] = useState(false)
  const handleInfoClick = () => {
    setInfoPageModal(true)
  }

  const handleInputChange = (event, type) => {
    formik.handleChange(event) // Update formik state
    const data = {}
    data.fixtureId = param.fixtureId
    data.type = type
    data.value = event.target.value
    ScorecardService.updateCustomScorecardField(data).then((res) => {
      if (res.status === 200) {
        setLoader(false)
        ToastComponent(res.message, 'success')
      }
    })
  }
  return (
    <>
      {gameDetails.game_type != 3 && (
        <TeamCommonScorecard
          scorecardDetails={scorecardDetails}
          selectedValue={selectedValue}
          playerList={playerList}
          handleChange={handleChange}
          visible={visible}
          setVisible={setVisible}
          loader={loader}
          fixtureDetails={fixtureDetails}
          statusValue={statusValue}
          setLoader={setLoader}
          fixtureId={param.fixtureId}
          param={param}
          changeInning={changeInning}
          isMobile={isMobile}
          formatFantasyPoints={formatFantasyPoints}
          infoPageModal={infoPageModal}
          handleInfoClick={handleInfoClick}
          handleInputChange={handleInputChange}
          handleMatchStatus={handleMatchStatus}
          completMarkModalVisible={completMarkModalVisible}
          setCompletMarkModalVisible={setCompletMarkModalVisible}
          completeMarkModalData={completeMarkModalData}
          finalScorecardModalVisible={finalScorecardModalVisible}
          setFinalScorecardModalVisible={setFinalScorecardModalVisible}
          fetchData={fetchData}
          defaultInning={defaultInning}
          teamId={param.teamId}
          gameDetails={gameDetails}
          commonScorecardLoading={commonScorecardLoading}
          setCommonScorecardLoading={setCommonScorecardLoading}
          scorecardColoumns={scorecardColoumns}
        />
      )}

      {gameDetails.game_type == 3 && (
        <TeamIndoorScorecard
          scorecardDetails={scorecardDetails}
          selectedValue={selectedValue}
          playerList={playerList}
          handleChange={handleChange}
          visible={visible}
          setVisible={setVisible}
          loader={loader}
          fixtureDetails={fixtureDetails}
          statusValue={statusValue}
          setLoader={setLoader}
          fixtureId={param.fixtureId}
          changeInning={changeInning}
          isMobile={isMobile}
          formatFantasyPoints={formatFantasyPoints}
          infoPageModal={infoPageModal}
          handleInfoClick={handleInfoClick}
          handleInputChange={handleInputChange}
          handleMatchStatus={handleMatchStatus}
          completMarkModalVisible={completMarkModalVisible}
          setCompletMarkModalVisible={setCompletMarkModalVisible}
          completeMarkModalData={completeMarkModalData}
          finalScorecardModalVisible={finalScorecardModalVisible}
          setFinalScorecardModalVisible={setFinalScorecardModalVisible}
          fetchData={fetchData}
          defaultInning={defaultInning}
          teamId={param.teamId}
          param={param}
          isLoading={isLoading}
          gameDetails={gameDetails}
          scorecardColoumns={scorecardColoumns}
        />
      )}

      <CompleteMarkModal visible={visible} setVisible={setVisible} />

      <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        data={completeMarkModalData}
        fixtureId={param.fixtureId}
        finalScorecardModalVisible={finalScorecardModalVisible}
        setFinalScorecardModalVisible={setFinalScorecardModalVisible}
      />
      <CompleteMarkModal visible={visible} setVisible={setVisible} />

      {gameDetails.game_type == 3 ? (
        <LegendInfoIndoor infoPageModal={infoPageModal} setInfoPageModal={setInfoPageModal} />
      ) : (
        <LegendInfo infoPageModal={infoPageModal} setInfoPageModal={setInfoPageModal} />
      )}
    </>
  )
}

export default ScoreCard
